import type { ReactNode } from "react";

/** A design-system card with a bordered header + dense body. */
export function HomeCard({ children }: { children: ReactNode }) {
  return <div className="overflow-hidden rounded-xl border bg-card">{children}</div>;
}

export function HomeCardHead({ title, action }: { title: string; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between border-b px-5 py-3.5">
      <h3 className="font-display text-sm font-bold tracking-tight text-card-foreground">
        {title}
      </h3>
      {action}
    </div>
  );
}
